export function rutFormatter(rut: string): string {
  if (!rut) return "";

  // Normalizar: sacar espacios, puntos, guiones y convertir a mayúsculas
  rut = rut.replace(/[^0-9kK]/g, "").toUpperCase();

  // Caso especial: si tiene menos de 2 caracteres no puede separar cuerpo/dv
  if (rut.length < 2) return rut;

  // Separar cuerpo y dígito
  const body = rut.slice(0, -1);
  const dv = rut.slice(-1);

  // Formatear cuerpo con puntos
  const formattedBody = body
    .split("")
    .reverse()
    .join("")
    .replace(/(\d{3})(?=\d)/g, "$1.")
    .split("")
    .reverse()
    .join("");

  return `${formattedBody}-${dv}`;
}
